import QualityEntityForm from '../components/layouts/QualityEntityForm'

import useQaRecordStatuses from '../hooks/useQaRecordStatuses'
import useQualityContents from '../hooks/useQualityContents'
import { ENTITY_TYPES } from '../hooks/useQualityEntity';

const QaRecord = () => {
    const {
        qaRecordStatuses,
        qaRecordTypes,
    } = useQaRecordStatuses()

    const {
        updateQaRecord,
        deleteQaRecord,
    } = useQualityContents()

    return (
        <QualityEntityForm
            entityType={ENTITY_TYPES.QA_RECORD}
            typeOptions={qaRecordTypes}
            statusOptions={qaRecordStatuses}
            hasReference
            hasClassification

            // Callback functions
            onUpdateDocument={updateQaRecord}
            onDelete={deleteQaRecord}
        />
    )
};

export default QaRecord
